const getConfigObj = () => {
  const env = import.meta.env?.VITE_REACT_APP_ENV || "development";

  switch (env) {
    case "development":
      return {
        API: {
          baseURL: "https://flowwise-api-dev.aq4.io/",
        },
      };
    case "uat":
      return {
        API: {
          baseURL: "https://flowwise-api-uat.aq4.io/",
        },
      };
    case "production":
      return {
        API: {
          baseURL: "https://flow-wise-api.aq4.io/",
        },
      };
    default:
      return {
        API: {
          baseURL: "https://flowwise-api-dev.aq4.io/",
        },
      };
  }
};

const config = getConfigObj();
export default config;
